import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING_DUE_DATE } from 'api/actionTypes';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrFormikField, { SR_FIELD_THEME_PARTNER_FORM } from 'client/components/SrFormikField';

import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';

const formFields = [
  {
    id: 'marketingPartnerListingId',
    type: 'hidden',
  },
  {
    id: 'dueDate',
    title: 'promise date',
    type: 'date_picker',
    properties: {
      placeholderValue: 'MM/DD/YYYY',
      placeholder: 'MM/DD/YYYY',
      dateFormat: 'MM/DD/YYYY',
    },
    validations: ['required', 'noPastDates'],
  },
  {
    id: 'dueDateChangedReason',
    title: "tell the partner why you're changing the date",
    type: 'long_text',
    properties: {
      placeholder: 'Write here...',
    },
    validations: ['required'],
  },
];

@withApiState({
  updateMarketingListingDueDateApiState: {
    action: SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING_DUE_DATE,
  },
})
class SrPartnerMarketListingEditDueDateModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    reloadDataTableMarketingPartnerListing: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    marketingPartnerListing: PropTypes.object,
    updateMarketingListingDueDateApiState: PropTypes.object.isRequired,
  };

  _onSubmit = (values) => {
    const {
      dispatch,
      marketingPartnerListing,
      reloadDataTableMarketingPartnerListing,
      onClose,
    } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING_DUE_DATE,
      payload: values,
      onSuccess: () => {
        reloadDataTableMarketingPartnerListing(marketingPartnerListing);
        onClose();
      },
    });
  };

  render() {
    const { updateMarketingListingDueDateApiState, onClose, marketingPartnerListing } = this.props;

    return (
      <SrDarkModal className="SrPartnerMarketListingEditDueDateModal">
        <SrModalContent onCloseIconClick={onClose}>
          <Formik
            validate={createFormValidationFn(formFields)}
            initialValues={createInitialValues({
              formFields: formFields,
              defaultValues: {
                marketingPartnerListingId: marketingPartnerListing.id,
                dueDate: marketingPartnerListing.dueDate,
              },
            })}
            onSubmit={this._onSubmit}
            render={(formikBag) => {
              return (
                <Form className="form">
                  <div className="container">
                    <div className="header">
                      <span className="title">Edit Promise Date</span>
                      <span className="subtitle">The partner will be notified</span>
                    </div>
                    <div className="content">
                      {formFields.map((formField) => (
                        <SrFormikField
                          key={formField.id}
                          formField={formField}
                          formikBag={formikBag}
                          className={SR_FIELD_THEME_PARTNER_FORM}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="footer">
                    <ButtonDeprecated
                      type="submit"
                      disabled={updateMarketingListingDueDateApiState.inProgress}
                    >
                      {updateMarketingListingDueDateApiState.inProgress
                        ? 'please wait...'
                        : 'submit'}
                    </ButtonDeprecated>
                  </div>
                </Form>
              );
            }}
          />
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrPartnerMarketListingEditDueDateModal.displayName = 'SrPartnerMarketListingEditDueDateModal';

export default SrPartnerMarketListingEditDueDateModal;
